export const BEDROOM_TYPES = ["HOUSE", "APARTMENT"];
export const EPC_TYPES = ["HOUSE", "OFFICE", "INDUSTRY", "COMMERCIAL", "APARTMENT",  "OTHER"];
export const MAIN_PROPERTY_TYPES = ["HOUSE", "APARTMENT"];
export const OTHER_PROPERTY_TYPE = "OTHER";
export const LAND_AREA_TYPES = ["LAND"];
export const MONTHLY_RENTAL_TYPES = ["HOUSE", "OFFICE", "INDUSTRY","COMMERCIAL", "APARTMENT","GARAGE","OTHER","HOMES_TO_BUILD"];


export function normalizePropertyType(type: string): string {
    return MAIN_PROPERTY_TYPES.includes(type) ? type : OTHER_PROPERTY_TYPE;
}

export function hasBedroom(type: string): boolean {
    return BEDROOM_TYPES.includes(type);
}

export function hasEpcScore(type: string): boolean {
    return EPC_TYPES.includes(type);
}

export function hasLandArea(type: string): boolean {
    return LAND_AREA_TYPES.includes(type);
}

export function hasMonthlyRental(type: string): boolean {
    return MONTHLY_RENTAL_TYPES.includes(type);
}
